import * as React from 'react';
import { styled } from '../theme-provider';
import { Text, TokenTextAppearance, TokenTextColor, TextTag, WhiteSpace, } from '../text';
import { getCommonProps } from '../helpers/common-props';
const StyledCharacterCounter = styled.span.withConfig({ displayName: "StyledCharacterCounter", componentId: "sc-omfthb" }) `margin-inline-start:auto;color:${({ theme }) => theme.colors.content.tertiary};`;
export const CharacterCounter = (props) => {
    const { limit, value = 0 } = props;
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledCharacterCounter, Object.assign({ "aria-hidden": true }, commonProps),
        React.createElement(Text, { tag: TextTag.span, color: TokenTextColor.inherit, appearance: TokenTextAppearance.label100, whiteSpace: WhiteSpace.nowrap },
            value,
            " / ",
            limit)));
};
